import React from 'react';
import BulletOnline from './BulletOnline.jsx';
import StreamerProfilPicture from './StreamerProfilPicture.jsx';
import StreamerResume from './StreamerResume.jsx';

class StreamerInfo extends React.Component {
	render () {
		// Si on affiche les lignes de chargement
		if (this.props.isLoading) {
			return (
				<div className="row rowStreamer row-mobile">
					<BulletOnline 
						isLoading={this.props.isLoading}
						isOnline={false} />
					<div className="col txtmiddle col-mobile">
						<div className="row row-mobile">
							<BulletOnline 
								isLoading={this.props.isLoading}
								isOnline={true} />
							<StreamerResume 
								isLoading={true}
								streamURL={null}
								streamPreviewImg="https://dummyimage.com/320x180/e8e8e8/e8e8e8.jpg" />
						</div>
					</div>
				</div>
			);
		} else {
			// Par défaut on considère le stream offline
			let isOnline = false;

			// Par défaut il n'y a pas d'url de stream
			let streamURL = false;

			// Par défaut on prend l'image de profil du streamer
			let streamImg = this.props.streamerInfo.profile_image_url;

			// Par défaut il n'y a pas de preview
			let streamPreviewImg = false;

			// Si on a des infos sur le stream en cours
			if (this.props.streamInfo !== false) {
				isOnline = true;
				streamURL = 'https://www.twitch.tv/' + this.props.streamerInfo.login;
				streamPreviewImg = this.props.streamInfo.thumbnail_url;
				streamPreviewImg = streamPreviewImg.replace('{width}', '320');
				streamPreviewImg = streamPreviewImg.replace('{height}', '180');
			}

			return (
				<div className="row rowStreamer row-mobile">
					<BulletOnline isOnline={isOnline} />
					<div className="col txtmiddle col-mobile">
						<div className="row row-mobile">
							<StreamerProfilPicture 
								streamURL={streamURL}
								streamImg={streamImg} />
							<StreamerResume
								streamerName={this.props.streamerNameCapitalized}
								streamURL={streamURL}
								game={this.props.streamInfo.game}
								viewers={this.props.streamInfo.viewer_count}
								streamPreviewImg={streamPreviewImg} />
						</div>
					</div>
				</div>
			);
		}
	}
}

export default StreamerInfo;